import type { Line, Lookups } from "./types";
// The one invoice rule (owner, 2026-11-04), the same file the server uses for the total it charges and the customer page.
import { invoiceSums, isWisconsin } from "../../../services/api/src/pricing";

export { isWisconsin };

export interface Totals { services: number; insuranceCost: number; subtotal: number; tax: number; refunds: number; total: number }

/**
 * Estimate totals, as the server, the customer page and the printed invoice work them out: lines at
 * quantity × (price − discount), insurance above the free amount at the insurance rate, Wisconsin sales tax when
 * the customer pays tax and the address is in WI, less refunds made after the ticket was paid in full.
 */
export function totals(lines: Pick<Line, "quantity" | "price" | "discount">[], insuranceAmount: number, taxed: boolean,
  pricing: Lookups["pricing"], refunds = 0): Totals {
  const s = invoiceSums(lines, insuranceAmount, taxed, pricing, refunds);
  return { services: s.items, insuranceCost: s.insurance, subtotal: s.subtotal, tax: s.tax, refunds: s.refunds, total: s.total };
}

/** Whether the ticket's customer pays Wisconsin tax ("Wis.", "Wisconsin" … count as WI). */
export const taxedTicket = (customer: { chargeSalesTax: boolean } | null | undefined, state: string | null) => !!customer?.chargeSalesTax && isWisconsin(state);
